export default [{
    path: '/products',
    name: 'products',
    component: () =>
        import ('@/views/pages/products/products-list/ProductsList.vue'),
    meta: {
        pageTitle: 'Products',
        breadcrumb: [{
            text: 'Products',
            active: true,
            to:'/products'
        }, ],
        resource: 'product',
        action: 'read',
    },
},
{
    path: '/products/view/:id',
    name: 'products-view',
    component: () =>
        import ('@/views/pages/products/products-view/ProductView.vue'),
    meta: {
        pageTitle: 'View product',
        breadcrumb: [
        {
            text: 'Products',
            to: '/products'
        },{
            text: 'View',
            active: true,
        },],
        resource: 'product',
        action: 'read',
    },
},
{
    path: '/products/edit/:id',
    name: 'products-edit',
    component: () =>
        import ('@/views/pages/products/products-edit/ProductEdit.vue'),
    meta: {
        pageTitle: 'Edit product',
        breadcrumb: [
        {
            text: 'Products',
            to: '/products',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'product',
        action: 'read',
    },
},
{
    path: '/products/add',
    name: 'products-add',
    component: () =>
        import ('@/views/pages/products/products-add/ProductAdd.vue'),
    meta: {
        pageTitle: 'Create product',
        breadcrumb: [
        {
            text: 'Products',
            to: '/products',
        },
        {
            text: 'Add',
            active: true,
        }
        ],
        resource: 'product',
        action: 'read',
    },
}
]